export default "__VITE_ASSET__CsjO6ONo__"